// This is where we set up the custom colors for the maps

let opacity = '0.4';

const GOVERNOR = [
  {
    name: 'Greg Abbott',
    color: '#EF564A',
    lean_color: '#F6A79D',
    rgbaColor: 'rgba(239,86,74,' + opacity + ')',
  },
  {
    name: "Gina Hinojosa",
    color: '#1755c5',
    lean_color: '#6DACD3',
    rgbaColor: 'rgba(23,85,194,' + opacity + ')',
  },
  {
    name: 'Pat Dixon',
    color: '#be9304',
    lean_color: '#edc74a',
    rgbaColor: 'rgba(190, 147, 4,' + opacity + ')',
  },
];

const SENATE = [
  {
    name: 'Ken Paxton',
    color: '#EF564A',
    lean_color: '#F6A79D',
    rgbaColor: 'rgba(239,86,74,' + opacity + ')',
  },
  {
    name: 'James Talarico',
    color: '#1755c5',
    lean_color: '#6DACD3',
    rgbaColor: 'rgba(23,85,194,' + opacity + ')',
  },
  {
    name: 'Ted Brown',
    color: '#be9304',
    lean_color: '#edc74a',
    rgbaColor: 'rgba(190, 147, 4,' + opacity + ')',
  },
];

const RAILROAD = [
  {
    name: 'Bo French',
    color: '#EF564A',
    lean_color: '#F6A79D',
    rgbaColor: 'rgba(239,86,74,' + opacity + ')',
  },
  {
    name: 'Jon Rosenthal',
    color: '#1755c5',
    lean_color: '#6DACD3',
    rgbaColor: 'rgba(23,85,194,' + opacity + ')',
  },
  {
    name: 'Arthur DiBianca',
    color: '#be9304',
    lean_color: '#edc74a',
    rgbaColor: 'rgba(190, 147, 4,' + opacity + ')',
  },
];

const LIEUTENANT_GOVERNOR = [
  {
    name: 'Dan Patrick',
    color: '#EF564A',
    lean_color: '#F6A79D',
    rgbaColor: 'rgba(239,86,74,' + opacity + ')',
  },
  {
    name: 'Vikki Goodwin',
    color: '#1755c5',
    lean_color: '#6DACD3',
    rgbaColor: 'rgba(23,85,194,' + opacity + ')',
  },
  {
    name: 'Anthony Cristo',
    color: '#be9304',
    lean_color: '#edc74a',
    rgbaColor: 'rgba(190, 147, 4,' + opacity + ')',
  },
  {
    // Same green as the Green Party pill ($color-green)
    name: 'Kevin McCormick',
    color: '#4f7d5a',
    lean_color: '#91ba9b',
    rgbaColor: 'rgba(79, 125, 90,' + opacity + ')',
  },
];

// Party colors for the other statewide races' maps, same as the races above
const partyColor = (name: string, party: string) =>
  ({
    Republican: {
      name,
      color: '#EF564A',
      lean_color: '#F6A79D',
      rgbaColor: 'rgba(239,86,74,' + opacity + ')',
    },
    Democrat: {
      name,
      color: '#1755c5',
      lean_color: '#6DACD3',
      rgbaColor: 'rgba(23,85,194,' + opacity + ')',
    },
    Libertarian: {
      name,
      color: '#be9304',
      lean_color: '#edc74a',
      rgbaColor: 'rgba(190, 147, 4,' + opacity + ')',
    },
    Green: {
      name,
      color: '#4f7d5a',
      lean_color: '#91ba9b',
      rgbaColor: 'rgba(79, 125, 90,' + opacity + ')',
    },
  }[party]);

const ATTORNEY_GENERAL = [
  partyColor('Mayes Middleton', 'Republican'),
  partyColor('Nathan Johnson', 'Democrat'),
  partyColor('Tom Oxford', 'Libertarian'),
];

const COMPTROLLER = [
  partyColor('Don Huffines', 'Republican'),
  partyColor('Sarah Eckhardt', 'Democrat'),
  partyColor('V. Alonzo Echavarria-Garza', 'Libertarian'),
  partyColor('Shehla Faizi', 'Green'),
];

const LAND_COMMISSIONER = [
  partyColor('Dawn Buckingham', 'Republican'),
  partyColor('Benjamin Flores', 'Democrat'),
  partyColor('Neill Snider', 'Libertarian'),
];

const AGRICULTURE_COMMISSIONER = [
  partyColor('Nate Sheets', 'Republican'),
  partyColor('Clayton Tucker', 'Democrat'),
  partyColor('Austin R. Kelly', 'Libertarian'),
];

// Map colors for each showcase race, keyed by contest office
const SHOWCASE_COLORS: { [office: string]: typeof GOVERNOR } = {
  Governor: GOVERNOR,
  'U.S. Senate': SENATE,
  'Texas Railroad Commission': RAILROAD,
  'Lieutenant Governor': LIEUTENANT_GOVERNOR,
  'Attorney General': ATTORNEY_GENERAL,
  Comptroller: COMPTROLLER,
  'Land Commissioner': LAND_COMMISSIONER,
  'Agriculture Commissioner': AGRICULTURE_COMMISSIONER,
};

const OTHER = '#888888';

const REPUBLICAN = '#EF564A'
const DEMOCRAT = '#1755c5'
const DEMOCRAT_LEAN = '#6DACD3'
const REPUBLICAN_LEAN = '#F6A79D';

const NEUTRAL = '#F2F2F2';
const TIE = '#8264B0';

export { GOVERNOR, SENATE, RAILROAD, SHOWCASE_COLORS, NEUTRAL, TIE, OTHER, REPUBLICAN, DEMOCRAT, DEMOCRAT_LEAN, REPUBLICAN_LEAN };